import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'inner-shadow-bottom-left',
  'IconInnerShadowBottomLeft',
  [
    ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
    ['path', { d: 'M6 12a6 6 0 0 0 6 6', key: 'svg-1' }],
  ],
);
